import Csr from '../modules/Csr'

export default class Ssl {
  constructor () {
    this.ssl = document.querySelector('.gf-ssl')

    if (!this.ssl) return false

    this.csrData = {}

    this.csrButton = document.querySelector('.gf-ssl__csrgen')

    this.productsWrapper = document.querySelector('.ssl-wrapper')

    this.type = null

    this.types = {
      oneDomainAlpha: this.oneDomainAlpha.bind(this),
      oneDomain: this.oneDomain.bind(this),
      wildcard: this.wildcard.bind(this),
    }

    this.buyButtons = document.querySelectorAll('.ssl-buy')

    this.controlButtons = document.querySelectorAll('.gf-ssl__icon')

    this.props = ['commonName', 'name', 'lastname', 'organization', 'organizationalUnit', 'localityName', 'stateOrProvinceName', 'countryName'];

    this.clearLocalStorage()
    this.setCountryValue()

    this.events()
  }

  events () {
    this.controlButtons.forEach(button => button.addEventListener('click',
      this.controlButtonsHandler.bind(this)))

    this.buyButtons.forEach(button => button.addEventListener('click',
      this.buyButtonsHandler.bind(this)))

    gform.addAction('gform_input_change', this.generateCsr.bind(this), 10)
    gform.addAction('gform_input_change', this.saveToLocalStorage.bind(this), 10)
    gform.addAction('gform_input_change', this.formatDomain.bind(this), 10)
  }

  buyButtonsHandler(e) {
    console.log(e.target.closest('.ssl-item').getAttribute('data-ssl-domain-type'))
    this.type = e.target.closest('.ssl-item').getAttribute('data-ssl-domain-type')
  }

  setCountryValue() {
    const country = this.ssl.querySelector('.gf-ssl__countryName select')
    country.value = 'ru'
  }

  formatDomain() {
    this.domainInput = this.ssl.querySelector('[data-ssl="commonName"]')
    this.types[this.type]()
  }

  oneDomainAlpha() {
    if (!this.domainInput.value.startsWith("www.")) {
      this.domainInput.value = "www." + this.domainInput.value;
    }
  }

  oneDomain() {
    this.domainInput.value = this.domainInput.value.replace(/www\./g, '');
  }

  wildcard() {
    if (!this.domainInput.value.startsWith("*.")) {
      this.domainInput.value = "*." + this.domainInput.value.replace(/www\.|\*\./g, '');
    }
  }

  clearLocalStorage() {
    this.props.forEach(prop => {
      localStorage.removeItem(prop)
    })
  }

  saveToLocalStorage (elem, formId, fieldId) {

    if(elem.dataset.ssl) {
      this.props.forEach(prop => {
        if (elem.closest('.gfield').classList.contains(`gf-ssl__${prop}`)) {
          localStorage.setItem(prop, elem.value)
        }
      })
    }
  }

  async generateCsr (elem, formId, fieldId) {
    const isCsrTrigger = elem.closest('.gfield').classList.contains('gf-ssl__csrgen');
    if (!isCsrTrigger) return false
    this.csrButton.classList.add('gf-ssl__csrgen--loader')

    const commonName = localStorage.getItem('commonName')
    const organization = localStorage.getItem('organization') === null
      ? `${localStorage.getItem('name')} ${localStorage.getItem('lastname')}`
      : localStorage.getItem('organization')
    const organizationalUnit = localStorage.getItem('organizationalUnit')
    const localityName = localStorage.getItem('localityName')
    const stateOrProvinceName = localStorage.getItem('stateOrProvinceName')
    const countryName = localStorage.getItem('countryName') || 'af'

    const csr = new Csr(commonName, organization,
      organizationalUnit, localityName,
      stateOrProvinceName,
      countryName)
    try {
      this.csrData = await csr.generate()
      if (this.csrData) {
        this.csrButton.classList.remove('gf-ssl__csrgen--loader')
        this.fillArea('key')
        this.fillArea('pkey')

        const csrWarning = document.querySelector('.gf-ssl__csr-warning')
        csrWarning.classList.add('gf-ssl__csr-warning--hidden')
      }
    } catch (error) {
      console.error(error)
    }
  }

  controlButtonsHandler (e) {
    const target = e.currentTarget
    const source = target.closest('.gf-ssl__csr').
      querySelector('.gf-ssl__csr-source')

    if (target.classList.contains('gf-ssl__icon--copy')) {
      navigator.clipboard.writeText(source.textContent.trim())
      target.classList.add('gf-ssl__icon--copied')
      setTimeout(() => target.classList.remove('gf-ssl__icon--copied'), 2000)
    } else {
      const blob = new Blob([source.textContent], { type: 'text/plain' })
      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(blob)
      const fileName = document.querySelector('.gf-ssl__commonName input').
        value.
        replace('.', '_')
      const extension = source.classList.contains('gf-ssl__csr-source--key')
        ? 'csr'
        : 'key'
      downloadLink.download = `${fileName}.${extension}`
      downloadLink.click()
    }

  }

  fillArea (key) {
    const sourceArea = document.querySelector(`.gf-ssl__csr-source--${key}`)
    sourceArea.textContent = this.csrData[key]
    sourceArea.closest('.gf-ssl__csr').classList.add('gf-ssl__csr--filled')

    document.querySelector(
      `.gf-ssl__entry-${key} input`).value = this.csrData[key]
  }
}

